function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { asSingleStyleConfig } from '../../utils/theme';
import { getColor } from '../../theme-tools';
import Input, { getDefaults } from './input';
import Button from './button';
var baseStyle = props => {
  var {
    theme
  } = props;
  var {
    focusBorderColor,
    focusBoxShadowColor
  } = getDefaults(props);
  // @ts-ignore
  var {
    container,
    field
  } = Input.baseStyle();
  var containerStyles = _objectSpread(_objectSpread({}, container), {}, {
    '&.tqc-input__search-group:focus-within': {
      boxShadow: "0 0 4px 1px ".concat(getColor(theme, focusBoxShadowColor)),
      '> .tqc-input': {
        borderColor: getColor(theme, focusBorderColor),
        _focus: {
          boxShadow: 'none'
        }
      }
    }
  });
  return {
    container: containerStyles,
    field,
    addon: _objectSpread(_objectSpread({}, Button.variants['primary'](props).button), {}, {
      border: 0,
      fontSize: 'lg',
      borderRadius: 'md',
      px: 2,
      minWidth: 11,
      height: 'auto'
    })
  };
};
export default asSingleStyleConfig({
  baseStyle
});